<template>
    <div>
        <div @click="openModal"
             style="display: inline; width: 100%">
            <slot name="button" />
        </div>

        <Teleport to="body">
            <div :id="id"
                 class="vue-modal-back native-modal-component"
                 v-bind:class="{ active: visible }">
                <div v-bind:class="{ active: visible }"
                     class="vue-modal shadow"
                     role="dialog"
                     aria-modal="true">
                    <div class="vue-modal-header d-flex align-items-center justify-content-between p-3">
                        <h5 class="font-600 mb-0 me-3">{{ title }}</h5>
                        <i class="fa-regular fa-circle-xmark cursor-pointer flex-shrink-0"
                           @click="closeModal"
                           style="font-size: 22px; cursor: pointer"
                        ></i>
                    </div>
                    <div class="vue-modal-body overflow-auto px-3 py-3">
                        <slot />
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    components: {},

    props: ["title"],

    emits: ["openModal", "closeModal"],

    name: "ModalComponent",

    data() {
        return {
            visible: false
        };
    },

    watch: {
        visible() {
            if (this.visible) {
                setTimeout(() => {
                    document.addEventListener("click", this.handleClick);
                    document.addEventListener("touchstart", this.handleClick);
                    document.addEventListener("keyup", this.handleClick);
                }, 400);
            } else {
                this.removeListeners();
            }
        },
    },

    computed: {
        id: () => 'modal-' + Math.random().toString(36).substring(10)
    },

    beforeUnmount() {
        this.removeListeners();
    },

    methods: {
        removeListeners() {
            document.removeEventListener("click", this.handleClick);
            document.removeEventListener("touchstart", this.handleClick);
            document.removeEventListener("keyup", this.handleClick);
        },
        closeModal() {
            this.visible = false;
            this.$emit("closeModal");
        },
        openModal() {
            this.visible = true;
            this.$emit("openModal");
        },
        handleClick(e) {
            if (e.target.classList.contains("vue-modal-back")) {
                this.closeModal();
            }
            if (e.key === "Escape") {
                this.closeModal();
            }
        }
    }
};
</script>

<style scoped>
.vue-modal-back {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
    visibility: hidden;
    transition: background-color 300ms ease, opacity 300ms ease, visibility 300ms ease;
    z-index: 1050;
    white-space: normal;
}

.vue-modal-back.active {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    visibility: visible;
}

.vue-modal {
    display: flex;
    flex-direction: column;
    width: 550px;
    max-width: 100%;
    max-height: 90vh;
    border: none !important;
    border-radius: 14px;
    background-color: #ffffff;
    color: #37474f;
    overflow: hidden;
    transform: translateY(-24px) scale(0.98);
    opacity: 0;
    transition: transform 300ms ease, opacity 300ms ease;
}

.vue-modal.active {
    transform: translateY(0) scale(1);
    opacity: 1;
}

.vue-modal-header {
    border-bottom: 1px solid #e6e6e6;
}

.vue-modal-body {
    flex: 1 1 auto;
    min-height: 0;
}
</style>
